import { useEffect, useState } from 'react'
import axios from 'axios'
import { useDataContext } from "../Context/dataContext";

function useBanks(accessToken) {
  const { url } = useDataContext();
  const [bankGbp, setBankGbp] = useState([]);
  const [bankEur, setBankEur] = useState([]);
  const [bankUsd, setBankUsd] = useState([]);

  useEffect(() => {
    const endpoints = [
      { setter: setBankGbp, path: '/Accgbp' },
      { setter: setBankEur, path: '/Acceur' },
      { setter: setBankUsd, path: '/Accusd' }
    ];

    const fetchRates = async () => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        };
        const results = await Promise.all(
          endpoints.map(e => axios.get(`${url}${e.path}`, config))
        );
        results.forEach((res, i) => endpoints[i].setter(res.data));
      } catch (error) {
        console.error('Error fetching currency rates:', error);
      }
    };

    if (accessToken) {
      fetchRates();
    }
  }, [url, accessToken]);

  return { bankGbp, bankEur, bankUsd };
}

export { useBanks }